import { apiRequest } from "../lib/apiClient";
import type { ExpenseCreate, ExpenseOut } from "./types";

export interface ExpenseListQuery {
  branchId?: string;
  category?: string;
  isRecurring?: boolean;
  dateFrom?: string;
  dateTo?: string;
}

export async function listExpenses(accessToken: string, query: ExpenseListQuery = {}): Promise<ExpenseOut[]> {
  return apiRequest<ExpenseOut[]>("/expenses", {
    accessToken,
    query: {
      branch_id: query.branchId,
      category: query.category,
      is_recurring: query.isRecurring,
      date_from: query.dateFrom,
      date_to: query.dateTo,
    },
  });
}

export async function createExpense(accessToken: string, body: ExpenseCreate): Promise<ExpenseOut> {
  return apiRequest<ExpenseOut>("/expenses", { method: "POST", accessToken, body });
}
